"use client";

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { trackEvent } from "@/lib/gtag";
import { useAppSelector } from "@/hooks/useAppSelector";

interface LogoutOverlayProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutOverlay: React.FC<LogoutOverlayProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { phoneNumber } = useAppSelector((state) => state.auth);
  const handleLogout = () => {
    trackEvent({
      action: "logout",
      category: "user",
      label: "User Logged Out",
      value: Number(phoneNumber),
    });

    onConfirm(); // Perform actual logout action
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "4px",
          padding: "16px",
          maxWidth: "400px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: "1.25rem",
          textAlign: "center",
          fontFamily: "inherit",
          letterSpacing: "1px",
        }}
      >
        Are you sure you want to logout?
      </DialogTitle>
      <DialogContent
        sx={{
          fontSize: "0.9rem",
          color: "gray",
          textAlign: "center",
          paddingBottom: "8px",
          fontFamily: "inherit",
          letterSpacing: "0.5px",
        }}
      >
        Click{" "}
        <strong className="font-semibold text-black-1">&quot;Yes&quot;</strong>{" "}
        to confirm or{" "}
        <strong className="font-semibold text-black-1">&quot;No&quot;</strong>{" "}
        to cancel.
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            background: "var(--color-gray)",
            color: "white",
            fontFamily: "inherit",
            textTransform: "none",
            letterSpacing: "1px",
            padding: "8px 24px",
            borderRadius: "4px",
            marginRight: "10px",
            "&:hover": {
              background: "rgba(105, 105, 105, 0.9)",
            },
          }}
        >
          No
        </Button>
        <Button
          onClick={handleLogout}
          autoFocus
          sx={{
            background: "var(--color-peach)",
            color: "white",
            fontFamily: "inherit",
            letterSpacing: "1px",
            textTransform: "none",
            padding: "8px 24px",
            marginLeft: "10px",
            borderRadius: "4px",
            "&:hover": {
              background: "rgba(186, 55, 55, 0.9)",
            },
          }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutOverlay;
